import React, { useEffect, useRef, useState } from 'react';
import { $t } from '@/modules/i18n';
// const Height = 50;
const defaultStyle = {
  height: 'auto'
}
// const computeStyle = {
//   height: '50px',
//   overflow: 'hidden',
// }
// 768 140
// 576 215
// 375 295
export default ({ message }) => {
  const attentionRef = useRef(null);
  const [isShowBtn, setIsShowBtn] = useState(false);
  const [currentStyle, setCurrentStyle] = useState(defaultStyle);
  useEffect(() => {
    // console.error('Window resized1', window.innerWidth);
    const handleResize = () => {
      // 处理窗口大小变化的逻辑
      // console.error('Window resized', window.innerWidth);
      const screenWidth = window.innerWidth;
      let limitHeight = 140;
      if (screenWidth > 768) {
        limitHeight = 140;
      } else if (screenWidth > 576) {
        limitHeight = 215;
      }  else {
        limitHeight = 295;
      }
      if (attentionRef.current) {
        const divHeight = attentionRef.current.getBoundingClientRect().height;
        // console.error(divHeight,limitHeight)
        if (divHeight > limitHeight) {
          setIsShowBtn(true);
          setCurrentStyle({
            height: `${limitHeight}px`,
            overflow: 'hidden',
          })
        }
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);
  const onHandleClickMoreBtn = () => {
    setIsShowBtn(false);
    setCurrentStyle(defaultStyle)
  }
  return (
    <section className="attention-container">
      <div id="attention" style={{position: "relative", top: -160}}></div>
      <div className="title">{$t(message.title)}</div>
      <div className="content-container" style={currentStyle}>
        <ol className="attention-list" ref={attentionRef}>
          {
            message.list.map((item, index) => {
              return (
                <li key={index} className="attention-item"  dangerouslySetInnerHTML={{__html: $t(item)}}></li>
              )
            })
          }
        </ol>
        {
        isShowBtn && <div className="mask">
            <div className='more-btn' onClick={() => onHandleClickMoreBtn()}>
              {$t(message.moreBtn)}
            </div>
          </div>
        }
      </div>
    </section>
  )
}